import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Response } from '../../../shared/models/response.model';
import { IndiceRésultats } from './models/indice-résultats';
import { IndiceCreateRequest } from './requests/create-request';
import { IndiceUpdateRequest } from './requests/update-request';

@Injectable({
  providedIn: 'root',
})
export class IndiceRésultatsService {
  #http = inject(HttpClient);

  readonly BASE_URL = '/indices-résultats';

  trouverParId(idIndice: string): Observable<IndiceRésultats> {
    return this.#http.get<IndiceRésultats>(this.BASE_URL + '/' + idIndice);
  }

  trouverTous = (idReferentiel: string) =>
    this.#http.get<Response<IndiceRésultats>>(this.BASE_URL, { params: { idReferentiel } });

  créer = (data: IndiceCreateRequest) => this.#http.post<IndiceRésultats[]>(this.BASE_URL, data);

  modifier(data: IndiceUpdateRequest) {
    return this.#http.put<string>(this.BASE_URL + '/', data);
  }

  supprimer(idIndice: string) {
    return this.#http.delete<void>(this.BASE_URL + '/' + idIndice);
  }
}
